var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXcllogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_70_1521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 19L10 16V38.167C10 39.1793 10.8207 40 11.833 40H41.167C42.1794 40 43 39.1793 43 38.167V30L27 19Z",
    fill: "#185C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 0H11.833C10.8207 0 10 0.820657 10 1.83299V10L27 20L36 23L43 20V10L27 0Z",
    fill: "#21A366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10H27V20H10V10Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M22.167 8H10V33H22.167C23.178 32.9967 23.9967 32.178 24 31.167V9.83299C23.9967 8.82203 23.178 8.00329 22.167 8Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.167 9H10V34H21.167C22.178 33.9967 22.9967 33.178 23 32.167V10.833C22.9967 9.82203 22.178 9.00329 21.167 9Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.167 9H10V32H21.167C22.178 31.9967 22.9967 31.178 23 30.167V10.833C22.9967 9.82203 22.178 9.00329 21.167 9Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.167 9H10V32H20.167C21.178 31.9967 21.9967 31.178 22 30.167V10.833C21.9967 9.82203 21.178 9.00329 20.167 9Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.83299 9H20.167C21.1793 9 22 9.82066 22 10.833V29.167C22 30.1793 21.1793 31 20.167 31H1.83299C0.820657 31 0 30.1793 0 29.167V10.833C0 9.82066 0.820657 9 1.83299 9Z",
    fill: "url(#paint0_linear_70_1521)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.677 25.958L9.533 19.983L6.00001 14.041H8.842L10.77 17.841C10.948 18.202 11.07 18.47 11.136 18.647H11.161C11.2877 18.359 11.421 18.0793 11.561 17.808L13.622 14.043H16.231L12.608 19.95L16.323 25.958H13.547L11.32 21.787C11.2151 21.6096 11.1261 21.4232 11.054 21.23H11.021C10.9558 21.4192 10.8692 21.6004 10.763 21.77L8.47002 25.958H5.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.167 0H27V10H43V1.83299C43 0.820657 42.1793 0 41.167 0Z",
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 20H43V30H27V20Z",
    fill: "#107C41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_70_1521",
    x1: 3.82184,
    y1: 7.56773,
    x2: 18.1782,
    y2: 32.4323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_70_1521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXcllogo);
export default __webpack_public_path__ + "static/media/xcllogo.a76a7a820f813d0279090232911d3ad0.svg";
export { ForwardRef as ReactComponent };